import { BaseTag, DashedTag } from '@praetorian-chariot/ui';

import { Tooltip } from '@/components/Tooltip';
import { Status } from '@/sections/customerManagement/types';
import { CUSTOMER_TYPE_LABELS, CustomerTypeValue } from '@/types';

export const StatusBadge = ({ status }: { status: Status }) => {
  switch (status) {
    case 'Active':
      return (
        <Tooltip title="Subscription is currently active">
          <div>
            <BaseTag className="text-chariot-text-primary bg-chariot-status-info border-chariot-stroke-info max-w-full truncate !px-2 !py-0.5 !text-[10px]">
              {status}
            </BaseTag>
          </div>
        </Tooltip>
      );
    case 'Upcoming':
      return (
        <Tooltip title="Subscription starts within 30 days">
          <div>
            <BaseTag className="text-chariot-text-primary bg-chariot-status-success border-chariot-stroke-success max-w-full truncate !px-2 !py-0.5 !text-[10px]">
              {status}
            </BaseTag>
          </div>
        </Tooltip>
      );
    case 'Completed':
      return (
        <Tooltip title="Subscription has ended">
          <div>
            <BaseTag className="text-chariot-text-primary bg-chariot-status-critical border-chariot-stroke-critical max-w-full truncate !px-2 !py-0.5 !text-[10px]">
              {status}
            </BaseTag>
          </div>
        </Tooltip>
      );
    case 'Paused':
      return (
        <Tooltip title="Subscription is paused">
          <div>
            <BaseTag className="text-chariot-text-primary bg-chariot-status-warning border-chariot-stroke-warning max-w-full truncate !px-2 !py-0.5 !text-[10px]">
              {status}
            </BaseTag>
          </div>
        </Tooltip>
      );
    case 'Setup':
      return (
        <Tooltip title="Account setup in progress">
          <div>
            <BaseTag className="text-chariot-text-primary bg-chariot-status-neutral border-chariot-stroke-neutral max-w-full truncate !px-2 !py-0.5 !text-[10px]">
              Setup
            </BaseTag>
          </div>
        </Tooltip>
      );
    default:
      return null;
  }
};

export const CustomerTypeTag = ({
  type,
}: {
  type?: CustomerTypeValue | { value: CustomerTypeValue };
}) => {
  const typeValue = typeof type === 'object' ? type?.value : type;

  if (!typeValue) return '-';
  return <DashedTag label={CUSTOMER_TYPE_LABELS[typeValue] || typeValue} />;
};
